<!--
 * @Description  : 订单详情
 * @Author       : git config user.sname
 * @Date         : 2026-01-08 10:48:51
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-04-09 16:34:21
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\order-management\components\detail.vue
-->
<template>
	<div class="h100 mt20 order-detail">
		<template>
			<el-divider content-position="left">订单基本信息</el-divider>
			<el-descriptions :column="3" size="medium" class="pd20">
				<el-descriptions-item label="订单编号">{{ pageInfo.orderInfo.orderNo || '' }}</el-descriptions-item>
				<el-descriptions-item label="订单类型">{{ pageInfo.orderInfo.orderType || '' }}</el-descriptions-item>
				<el-descriptions-item label="订单金额">{{ pageInfo.orderInfo.orderAm || '' }}</el-descriptions-item>
				<el-descriptions-item label="归属方">{{ pageInfo.orderInfo.owner || '' }}</el-descriptions-item>
				<el-descriptions-item label="订单状态">{{ pageInfo.orderInfo.orderStatus || '' }}</el-descriptions-item>
				<el-descriptions-item label="开票状态"
					><span :class="[pageInfo.orderInfo.invoiceStatus == 1 ? 'color-success' : 'color-failed']">{{
						dictStatusText('invoiceState', pageInfo.orderInfo.invoiceStatus)
					}}</span></el-descriptions-item
				>
				<el-descriptions-item label="订单创建时间">{{ pageInfo.orderInfo.createDate || '' }}</el-descriptions-item>
				<el-descriptions-item label="订单结束时间">{{ pageInfo.orderInfo.finishDate || '' }}</el-descriptions-item>
				<el-descriptions-item label="订单创建">{{ pageInfo.orderInfo.createUser || '' }}</el-descriptions-item>
			</el-descriptions>
		</template>
		<template>
			<el-divider content-position="left">支付结算信息</el-divider>
			<el-descriptions :column="3" size="medium" class="pd20 mb10">
				<el-descriptions-item label="下单人">{{ pageInfo.payInfo.createUser || '' }}</el-descriptions-item>
				<el-descriptions-item label="支付时间">{{ pageInfo.payInfo.createDate || '' }}</el-descriptions-item>
				<el-descriptions-item label="支付方式">{{ pageInfo.payInfo.payType || '' }}</el-descriptions-item>
				<el-descriptions-item label="支付金额">{{ pageInfo.payInfo.amount || '' }}</el-descriptions-item>
				<el-descriptions-item label="支付状态">{{ pageInfo.payInfo.status || '' }}</el-descriptions-item>
				<el-descriptions-item label="归属主体">{{ pageInfo.payInfo.sysNo || '' }}</el-descriptions-item>
				<el-descriptions-item label="支付流水号">{{ pageInfo.payInfo.payNo || '' }}</el-descriptions-item>
				<el-descriptions-item label="支付会员">{{ pageInfo.payInfo.payUser || '' }}</el-descriptions-item>
				<el-descriptions-item label="通联云订单号">{{ pageInfo.payInfo.orderNo || '' }}</el-descriptions-item>
			</el-descriptions>
		</template>
		<template>
			<el-divider content-position="left">商品信息</el-divider>
			<div class="table mb10">
				<vxe-table
					ref="xTable"
					:data="tableObj.tableData1"
					align="left"
					border
					size="small"
					auto-resize
					resizable
					show-overflow="tooltip"
					show-header-overflow="tooltip"
				>
					<vxe-table-column type="seq" title="序号" width="60px" align="center"></vxe-table-column>
					<vxe-table-column field="goodNo" title="商品编号" min-width="180px" align="center"></vxe-table-column>
					<vxe-table-column field="goodName" title="商品名称" min-width="180px" align="center"></vxe-table-column>
					<vxe-table-column field="isGive" title="是否赠品" width="120px" align="center"></vxe-table-column>
					<vxe-table-column field="goodAttr" title="商品属性" min-width="120px" align="center"></vxe-table-column>
					<vxe-table-column field="goodType" title="商品类型" min-width="120px" align="center"></vxe-table-column>
					<vxe-table-column field="goodSup" title="商品大类" min-width="140px" align="center"></vxe-table-column>
					<vxe-table-column field="goodSub" title="商品子类" min-width="140px" align="center"></vxe-table-column>
					<vxe-table-column field="goodAm" title="商品价格" width="120px" align="center"></vxe-table-column>
					<vxe-table-column field="goodNum" title="商品数量" width="120px" align="center"></vxe-table-column>
					<vxe-table-column field="subAm" title="商品总额" width="140px" align="center"></vxe-table-column>
					<vxe-table-column title="操作" width="100px" align="center">
						<template v-slot="{ row }">
							<el-button type="success" size="mini" plain round @click="handleDetail(row)">查看</el-button>
						</template>
					</vxe-table-column>
				</vxe-table>
			</div>
			<div class="footer">
				<vxe-pager
					border
					background
					size="mini"
					align="center"
					:current-page="pageConfig.tableData1.current"
					:page-size="pageConfig.tableData1.size"
					:total="pageConfig.tableData1.total"
					class="pager"
					:page-sizes="[10, 20, 50, 100]"
					:layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump']"
					@page-change="pageChange($event, 'tableData1')"
				>
				</vxe-pager>
			</div>
		</template>
		<template>
			<el-divider content-position="left">名义分账信息</el-divider>
			<div class="table mb10">
				<vxe-table
					ref="xTable"
					:data="tableObj.tableData2"
					align="left"
					border
					size="small"
					auto-resize
					resizable
					show-overflow="tooltip"
					show-header-overflow="tooltip"
				>
					<vxe-table-column type="seq" title="序号" width="60px" align="center"></vxe-table-column>
					<vxe-table-column field="collectTenant" title="收款公司" min-width="180px" align="center"></vxe-table-column>
					<vxe-table-column field="collectAccount" title="收款账户名" min-width="180px" align="center"></vxe-table-column>
					<vxe-table-column field="collectNo" title="收款账号" min-width="180px" align="center"></vxe-table-column>
					<vxe-table-column field="collectBank" title="开户行" min-width="180px" align="center"></vxe-table-column>
					<vxe-table-column field="collectLink" title="联系人" width="120px" align="center"></vxe-table-column>
					<vxe-table-column field="taxNo" title="税号" min-width="180px" align="center"></vxe-table-column>
					<vxe-table-column field="orderAm" title="商品总额" width="140px" header-align="center" align="right">
						<template #default="{ row }">
							<span>{{ !!row.orderAm ? row.orderAm + ' 元' : '' }}</span>
						</template>
					</vxe-table-column>
					<vxe-table-column field="merRatio" title="分账比例" min-width="150px" align="center">
						<template #default="{ row }">
							<span>{{ !!row.merRatio ? row.merRatio + ' %' : '' }}</span>
						</template>
					</vxe-table-column>
					<vxe-table-column field="merAm" title="名义分账金额" width="120px" header-align="center" align="right">
						<template #default="{ row }">
							<span>{{ !!row.merAm ? row.merAm + ' 元' : '' }}</span>
						</template>
					</vxe-table-column>
				</vxe-table>
			</div>
			<div class="footer">
				<vxe-pager
					border
					background
					size="mini"
					align="center"
					:current-page="pageConfig.tableData2.current"
					:page-size="pageConfig.tableData2.size"
					:total="pageConfig.tableData2.total"
					class="pager"
					:page-sizes="[10, 20, 50, 100]"
					:layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump']"
					@page-change="pageChange($event, 'tableData2')"
				>
				</vxe-pager>
			</div>
		</template>
		<template v-if="pageInfo.refundInfo && pageInfo.refundInfo.createUser">
			<el-divider content-position="left">退款信息</el-divider>
			<el-descriptions :column="3" size="medium" class="pd20">
				<el-descriptions-item label="退款申请">{{ pageInfo.refundInfo.createUser || '' }}</el-descriptions-item>
				<el-descriptions-item label="退款申请时间">{{ pageInfo.refundInfo.createDate || '' }}</el-descriptions-item>
				<el-descriptions-item label="退款类型">{{ pageInfo.refundInfo.isAuto || '' }}</el-descriptions-item>
				<el-descriptions-item label="退款方式">{{ pageInfo.refundInfo.refundWay || '' }}</el-descriptions-item>
				<el-descriptions-item label="退款金额">{{ pageInfo.refundInfo.amount || '' }}</el-descriptions-item>
				<el-descriptions-item label="退款状态">{{ pageInfo.refundInfo.status || '' }}</el-descriptions-item>
				<el-descriptions-item label="退款原因">{{ pageInfo.refundInfo.refundReason || '' }}</el-descriptions-item>
				<el-descriptions-item label="退款备注">{{ pageInfo.refundInfo.remark || '' }}</el-descriptions-item>
				<el-descriptions-item label="退款审核人">{{ pageInfo.refundInfo.auditor || '' }}</el-descriptions-item>
				<el-descriptions-item label="审核通过时间">{{ pageInfo.refundInfo.auditTime || '' }}</el-descriptions-item>
				<el-descriptions-item label="退款完成时间">{{ pageInfo.refundInfo.finishTime || '' }}</el-descriptions-item>
				<el-descriptions-item label="退款流水号">{{ pageInfo.refundInfo.bizOrderNo || '' }}</el-descriptions-item>
				<el-descriptions-item label="退款申请材料">
					<public-upload ref="upload" :isViewMode="true" listType="text" :viewFilesList="pageInfo.refundInfo.files"></public-upload>
				</el-descriptions-item>
			</el-descriptions>
		</template>
		<template>
			<el-divider content-position="left">订单记录</el-divider>
			<div class="table mb10">
				<vxe-table
					ref="xTable"
					:data="tableObj.tableData3"
					align="left"
					border
					size="small"
					auto-resize
					resizable
					show-overflow="tooltip"
					show-header-overflow="tooltip"
				>
					<vxe-table-column type="seq" title="序号" width="60px" align="center"></vxe-table-column>
					<vxe-table-column field="opeName" title="操作记录" min-width="180px" align="center"></vxe-table-column>
					<vxe-table-column field="createDate" title="操作时间" min-width="180px" align="center"></vxe-table-column>
					<vxe-table-column field="remark" title="备注" min-width="180px" align="center"></vxe-table-column>
				</vxe-table>
			</div>
			<div class="footer">
				<vxe-pager
					border
					background
					size="mini"
					align="center"
					:current-page="pageConfig.tableData3.current"
					:page-size="pageConfig.tableData3.size"
					:total="pageConfig.tableData3.total"
					class="pager"
					:page-sizes="[10, 20, 50, 100]"
					:layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump']"
					@page-change="pageChange($event, 'tableData3')"
				>
				</vxe-pager>
			</div>
		</template>

		<!-- 查看商品详情弹窗 -->
		<el-dialog :visible.sync="visible" v-bind="dialogOptions">
			<div style="padding-right: 20px">
				<bm-panel title="商品集及商品名称信息">
					<el-form label-width="130px" class="dialog-form">
						<el-form-item label="商品集">{{ dialogInfo.proValueName || '' }}</el-form-item>
						<el-form-item label="商品名称">{{ dialogInfo.sname || '' }}</el-form-item>
					</el-form>
				</bm-panel>
				<bm-panel title="#1 基本信息">
					<el-form label-width="130px" class="dialog-form">
						<el-form-item label="商品属性">{{ dialogInfo.proAttrName || '' }}</el-form-item>
						<el-form-item label="商品类型">{{ dialogInfo.proTypeName || '' }}</el-form-item>
						<el-form-item label="商品大类">{{ dialogInfo.proSupName || '' }}</el-form-item>
						<el-form-item label="商品子类">{{ dialogInfo.proSubName || '' }}</el-form-item>
						<el-form-item label="归属主体">{{ dialogInfo.applySubName || '' }}</el-form-item>
						<el-form-item label="商品简介">{{ dialogInfo.proIntro || '' }}</el-form-item>
						<el-form-item label="是否组合商品">{{ dialogInfo.isJoint == 1 ? '是' : '否' }}</el-form-item>
						<!-- <el-form-item label="商品识别码">{{ dialogInfo.proId || '' }}</el-form-item> -->
					</el-form>
				</bm-panel>
				<bm-panel title="#2 收费信息">
					<el-form label-width="130px" class="dialog-form">
						<el-form-item label="收费方式">{{ dialogInfo.feeTypeName || '' }}</el-form-item>
						<el-form-item label="收费规则">{{ dialogInfo.cycleTypeName || '' }}</el-form-item>

						<!-- 周期收费 -->
						<template v-if="dialogInfo.feeType == '0'">
							<el-form-item label="可订购周期">{{ dialogInfo.cycleDigitName || '' }}</el-form-item>
							<el-form-item label="商品价格">{{ dialogInfo.fixPrice + ' 元' || '' }}</el-form-item>
						</template>

						<!-- 按次收费 -->
						<template v-if="dialogInfo.feeType == '1'">
							<el-form-item label="商品价格" v-if="dialogInfo.cycleType == 0">
								{{ dialogInfo.fixPrice + ' 元' || '' }}
							</el-form-item>

							<!-- 阶梯价 -->
							<template v-if="dialogInfo.cycleType == 1">
								<el-form-item label="阶梯计费类型">{{ ['按数量/次数', '按金额费率'][dialogInfo.stepType] }}</el-form-item>

								<!-- 按金额费率 -->
								<template v-if="dialogInfo.stepType === 1">
									<el-form-item label="计费基数">{{ dialogInfo.billBaseName }}</el-form-item>
									<el-form-item label="费率数值(%)">{{ dialogInfo.rateValue + ' %' }}</el-form-item>
									<el-form-item label="是否开启价格限制">{{ dialogInfo.isLimit == 1 ? '是' : '否' }}</el-form-item>
									<el-form-item label="最低收费" v-if="dialogInfo.isLimit == 1">{{ dialogInfo.minFee + ' 元' }}</el-form-item>
									<el-form-item label="最高收费" v-if="dialogInfo.isLimit == 1">{{ dialogInfo.maxFee + ' 元' }}</el-form-item>
								</template>

								<!-- 按数量/次数 -->
								<template v-if="dialogInfo.stepType === 0">
									<el-form-item label="计量单位">{{ dialogInfo.measureUnitName }}</el-form-item>
									<el-form-item label="计量依据">{{ dialogInfo.measureBasisName }}</el-form-item>
									<el-form-item label="阶梯价格" v-if="dialogInfo.cycleType == 1">
										<div v-for="(item, index) in dialogInfo.stairPriceList" :key="'阶梯价格' + index">
											{{ `使用 ${item.useTime} 次，价格 ${item.usePrice} 元` }}
										</div>
									</el-form-item>
								</template>
							</template>
						</template>

						<el-form-item label="是否分账">{{ dialogInfo.isDevide == 1 ? '是' : '否' }}</el-form-item>

						<!-- 分账 -->
						<template v-if="dialogInfo.isDevide == 1">
							<el-form-item label="分账方式">{{ dialogInfo.devideType == 1 ? '按比例分账' : '按金额分账' }}</el-form-item>
							<!-- 按比例分账 -->
							<template v-if="dialogInfo.devideType == 1">
								<el-form-item label="平台分账比例">{{ dialogInfo.platRatio + ' %' || '' }}</el-form-item>
								<el-form-item label="商家分账比例">{{ dialogInfo.merRatio + ' %' || '' }}</el-form-item>
							</template>
							<!-- 按金额分账 -->
							<el-form-item label="平台分账金额">{{ dialogInfo.platRatio + ' 元' || '' }}</el-form-item>
							<el-form-item label="商家分账金额">{{ dialogInfo.merRatio + ' 元' || '' }}</el-form-item>

							<el-form-item label="分账主体">{{ dialogInfo.subTenant || '' }}</el-form-item>
							<el-form-item label="收款公司">{{ dialogInfo.collectTenant || '' }}</el-form-item>
							<el-form-item label="收款账户名">{{ dialogInfo.collectAccount || '' }}</el-form-item>
							<el-form-item label="收款账号">{{ dialogInfo.collectNo || '' }}</el-form-item>
							<el-form-item label="收款开户行">{{ dialogInfo.collectBank || '' }}</el-form-item>
							<el-form-item label="收款联系人">{{ dialogInfo.collectLink || '' }}</el-form-item>
							<el-form-item label="税号">{{ dialogInfo.taxNo || '' }}</el-form-item>
						</template>
					</el-form>
				</bm-panel>
				<bm-panel title="#3 组合商品信息" v-if="dialogInfo.isJoint == 1">
					<el-form label-width="130px" class="dialog-form">
						<el-form-item label="赠送商品"></el-form-item>
					</el-form>
					<vxe-table align="center" :data="dialogInfo.giveGoodList" border>
						<vxe-table-column title="名称" field="sname" min-width="130px"></vxe-table-column>
						<vxe-table-column title="价格" width="110px">
							<template #default>0元</template>
						</vxe-table-column>
						<vxe-table-column title="数量" field="giveNum" width="110px"></vxe-table-column>
					</vxe-table>
				</bm-panel>
				<bm-panel :title="`#${dialogInfo.isJoint == 1 ? 4 : 3} 商品图片信息`">
					<div class="img-container">
						<div class="img-box" v-for="item in dialogInfo.imgList" :key="item.id">
							<el-image class="img" :src="item.previewUrl" :preview-src-list="[item.previewUrl]"> </el-image>
							<span class="img-text">{{ item.fileName }}</span>
						</div>
					</div>
				</bm-panel>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import * as Api from '@/api/modules/order-management.js'
import { mapState } from 'vuex'
import viewVue from '@/views/operation-management/commodity-management/product-list/components/view.vue'
import bmPanel from '@/components/panel/Panel'

export default {
	components: { viewVue, bmPanel },
	data() {
		return {
			orderId: '',
			pageInfo: {
				orderInfo: {},
				payInfo: {},
				refundInfo: {}
			},
			tableObj: {
				// 商品表格数据
				tableData1: [],
				// 分账记录表格数据
				tableData2: [],
				// 订单记录表格数据
				tableData3: []
			},
			pageConfig: {
				tableData1: { current: 1, size: 10, total: 0 },
				tableData2: { current: 1, size: 10, total: 0 },
				tableData3: { current: 1, size: 10, total: 0 }
			},
			// 商品详情弹窗
			visible: false,
			dialogOptions: {
				title: '商品详情',
				width: '800px',
				// closeOnClickModal: false,
				top: '10vh'
			},
			dialogInfo: {
				giveGoodList: [],
				imgList: []
			}
		}
	},
	created() {
		this.orderId = this.$route.query.orderId
		//TODO 调用接口
		if (!!this.orderId) {
			this.getPageDetail()
			this.getTableData('tableData1')
			this.getTableData('tableData2')
			this.getTableData('tableData3')
		}
	},
	methods: {
		//* 获取详情
		getPageDetail() {
			if (!this.orderId) {
				return
			}
			let params = { orderId: this.orderId }
			Api.getOrderDetail(params)
				.then((res) => {
					this.pageInfo = res.data
				})
				.catch((err) => {})
		},

		// 获取分页商品
		getTableData(type) {
			let params = {
				current: this.pageConfig[type].tcurrent,
				size: this.pageConfig[type].size,
				orderId: this.orderId
			}

			let apiName = ''
			switch (type) {
				case 'tableData1':
					apiName = 'selectOrderGoodsPage'
					break
				case 'tableData2':
					apiName = 'selectOrderSubPage'
					break
				case 'tableData3':
					apiName = 'selectOrderOperatePage'
					break
			}
			Api[apiName](params)
				.then((res) => {
					this.tableObj[type] = res.data.records
					this.pageConfig[type].total = parseInt(res.data.total)
				})
				.catch((err) => {})
		},
		//TODO 分页
		pageChange(obj, type) {
			this.pageConfig[type].size = obj.pageSize
			this.pageConfig[type].current = obj.currentPage
			this.getTableData(type)
		},

		// 查看商品详情
		handleDetail(row) {
			this.visible = true
			let params = { id: row.id }
			Api.getOrderGoodsDetail(params)
				.then((res) => {
					// 收费信息处理
					let _feeType = res.data.feeType !== '' ? parseFloat(res.data.feeType) : ''
					res.data.feeTypeName = _feeType !== '' ? ['周期收费', '按次收费'][_feeType] : ''

					if (_feeType === 0) {
						res.data.cycleTypeName = res.data.cycleType !== '' ? ['按年收费', '按月收费', '按天收费'][res.data.cycleType] : ''
					}

					if (_feeType === 1) {
						res.data.cycleTypeName = res.data.cycleType !== '' ? ['固定单价', '阶梯单价'][res.data.cycleType] : ''
					}

					// 图片信息处理
					res.data.imgList.map((x) => {
						x.previewUrl = process.env.VUE_APP_UPLOAD_URL + x.fileDirectory + x.serverName
						return x
					})

					// 赋值
					this.dialogInfo = res.data
				})
				.catch((err) => {})
		}
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		},
		// 开票状态码表
		invoiceStateList() {
			return [
				{ sname: '未开票', value: -1 },
				{ sname: '开票中', value: 0 },
				{ sname: '已开票', value: 1 },
				{ sname: '开票失败', value: 2 },
				{ sname: '已红冲', value: 3 },
				{ sname: '红冲失败', value: 4 }
			]
		},
		// 不同码表展示的文字
		dictStatusText() {
			let item = [{ sname: '' }]
			let that = this
			return function(type, value) {
				switch (type) {
					// 开票
					case 'invoiceState':
						item = that.invoiceStateList.find((x) => x.value === parseFloat(value))
						break
				}
				return (item && item.sname) || ''
			}
		}
	}
}
</script>
<style lang="less" scoped>
.order-detail {
	.pd20 {
		padding: 20px;
	}
	/deep/.el-divider__text.is-left {
		left: 80px;
	}
}

.img-container {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}

.img-box {
	display: flex;
	flex-direction: column;
	padding: 10px;
	max-width: 200px;

	.img {
		width: 100%;
	}

	.img-text {
		line-height: 18px;
		text-align: center;
		padding: 10px 0;
	}
}

.dialog-form /deep/ .el-form-item {
	margin-bottom: 0;
}
</style>
